import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CmsConfig, FeaturesConfigModule, I18nModule, provideConfig } from '@spartacus/core';
import { FormErrorsModule, StarRatingModule } from '@spartacus/storefront';
import { CustomProductReviewsComponent } from './product-reviews.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    I18nModule,
    StarRatingModule,
    FormErrorsModule,
    FeaturesConfigModule,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductReviewsTabComponent: {
          component: CustomProductReviewsComponent,
        },
      },
    }),
  ],
  declarations: [CustomProductReviewsComponent],
  exports: [CustomProductReviewsComponent],
})
export class CustomProductReviewsModule {}
